<template>
  <b-container 
    class="section bg-neon-blue-grad" 
    fluid
  >
    <b-row class="section p-5">
      <b-col class="m-auto">
        <div class="d-flex justify-content-center pb-4">
          <h1>Start using the Aconex Accelerator Today</h1>
        </div>
        <div class="d-flex justify-content-center pb-4">
          <b-img
            :src="require('../assets/browser-smart-construction-button.png')"
            style="max-width: 50vw;"
          />
        </div>
        <div class="d-flex justify-content-center pb-4">
          <b-button 
            variant="orange"
            size="lg"
            href="https://trinapp.com"
          >
            <h4 class="mb-0">Get Started</h4>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "CallToActionAconexRegister",
    props: {
      content: Object
    }
  }
  </script>